import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70dbfe0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-6" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row justify-between lg:h-40 gap-6" }

import { type Ref, ref, computed, onMounted } from "vue";

import {
  TotalCapitalMetric,
  TotalShareholdersMetric,
  TotalPaidMetric,
  TotalSubsMetric,
} from "@/services/metrics/types";

import { MetricService } from "@/services/metrics/MetricService";
import MectricCardShares from "@/components/molecules/MetricCardShares.vue";
import MectricCardTotal from "@/components/molecules/MetricCardTotal.vue";
import ShareholderTable from "@/components/organisms/ShareholdersTable.vue";

import { toBadgeFormat } from "@/services/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholdersView',
  setup(__props) {

const metricService = new MetricService();
const totalCapitalMetric: Ref<undefined | TotalCapitalMetric> = ref();
const totalShareholdersMetric: Ref<undefined | TotalShareholdersMetric> = ref();
const totalPaidMetric: Ref<undefined | TotalPaidMetric> = ref();
const totalSubsMetric: Ref<undefined | TotalSubsMetric> = ref();
const totalPayDescription = computed(() => {
  if (totalCapitalMetric.value == undefined) {
    return "Cargando...";
  }

  const capitalUf = toBadgeFormat(totalCapitalMetric.value.capitalUf);
  return `De UF ${capitalUf}`;
});

const totalEmitedSharesDescription = computed(() => {
  if (totalCapitalMetric.value == undefined) {
    return "Cargando...";
  }

  const capitalShares = toBadgeFormat(totalCapitalMetric.value.capitalShares);
  return `De ${capitalShares} acciones emitidas`;
});

const totalShareholders = computed(() => {
  if (totalShareholdersMetric.value == undefined) {
    return "0";
  }

  const shareholders = toBadgeFormat(
    totalShareholdersMetric.value.totalShareholders
  );
  return shareholders;
});

const totalPaidDescription = computed(() =>  
  totalSubsMetric?.value?.paidInCapital ? `UF ${toBadgeFormat(totalSubsMetric?.value?.paidInCapital)}` : 0
);

const totalSubs = computed(() => {
  if (totalSubsMetric.value == undefined) {
    return "0";
  }

  const totalShares = toBadgeFormat(totalSubsMetric.value.totalShares);
  return `${totalShares}`;
});

async function fetchMetrics() {
  const response = await metricService.getTotalCapital();

  if (!response.success) {
    console.log("Error al intentar obtener las métricas");
    return;
  }

  totalCapitalMetric.value = response.data;

  const response1 = await metricService.getTotalShareholders();

  if (!response1.success) {
    console.log("Error al intentar obtener las métricas");
    return;
  }

  totalShareholdersMetric.value = response1.data;

  const responseShareholder = await metricService.getTotalShareholders();

  if (!responseShareholder.success) {
    console.log("Error al intentar obtener las métricas");
    return;
  }

  totalShareholdersMetric.value = responseShareholder.data;

  const responPaid = await metricService.getPaidInCapital();

  if (!responPaid.success) {
    console.log("Error al intentar obtener las métricas");
    return;
  }

  totalPaidMetric.value = responPaid.data;

  const responseSubs = await metricService.getTotalSubs();

  if (!responseSubs.success) {
    console.log("Error al intentar obtener las métricas");
    return;
  }

  totalSubsMetric.value = responseSubs.data;
}

onMounted(() => {
  fetchMetrics();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MectricCardTotal, {
        class: "min-w-[300px] w-ful",
        title: "Capital Pagado",
        description: totalPayDescription.value,
        metric: totalPaidDescription.value
      }, null, 8, ["description", "metric"]),
      (totalSubsMetric.value)
        ? (_openBlock(), _createBlock(MectricCardShares, {
            key: 0,
            class: "min-w-[300px] w-full",
            title: "Acciones suscritas",
            description: totalEmitedSharesDescription.value,
            metric: totalSubs.value,
            seriea: totalSubsMetric.value?.totalSharesA,
            serieb: totalSubsMetric.value?.totalSharesB
          }, null, 8, ["description", "metric", "seriea", "serieb"]))
        : _createCommentVNode("", true),
      (totalShareholdersMetric.value)
        ? (_openBlock(), _createBlock(MectricCardShares, {
            key: 1,
            class: "min-w-[300px] w-full",
            title: "Nº de accionistas",
            metric: totalShareholders.value,
            seriea: totalShareholdersMetric.value?.groupAShareholders,
            serieb: totalShareholdersMetric.value?.groupBShareholders
          }, null, 8, ["metric", "seriea", "serieb"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ShareholderTable)
  ]))
}
}

})